import {Component, OnInit, ViewChild} from '@angular/core';

// import { AdvtService } from '../../_services/advt.service';
// import { AlertService } from '../../_services';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  @ViewChild("imagex") imagex: any;


  logoimage: any;
  constructor(
  ) { }

  ngOnInit() {
    window.scroll(0,0);
    this.logoimage = '../../assets/images/logo.png';
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/terms-conditions/terms-conditions.component.ts